import { navigationReducer } from './navigation';
export * from './navigation';

export default navigationReducer;
